import { z } from "zod";
import { defineRoute } from "../http/route.js";
/** The desktop's operating system; the web has no messaging (ADR 0016 point 5). */
export const ImPlatform = z.enum(["macos", "windows", "linux"]).meta({ id: "ImPlatform" });
export const ImSession = z
    .object({
    userId: z.string().describe("The person's messaging id"),
    token: z.string(),
    expiresIn: z.number().int().positive().describe("Seconds; ask for a new session before then"),
    apiUrl: z.string(),
    wsUrl: z.string(),
    platformId: z.number().int().describe("The platform id the messaging SDK logs in with"),
})
    .meta({ id: "ImSession" });
export const createImSession = defineRoute({
    id: "messaging.session.create",
    method: "POST",
    path: "/v1/im/session",
    surface: "tenant",
    auth: "user",
    permission: "conversation:create",
    marks: ["tenant"],
    summary: "Messaging credentials for this desktop device; the messaging identity is created on first use. Refused for web devices",
    prd: ["IM-1"],
    request: { body: z.object({ platform: ImPlatform }) },
    responses: { 200: { description: "The session", schema: ImSession } },
    errors: ["AUTH_REQUIRED", "TENANT_REQUIRED", "PERMISSION_DENIED", "RATE_LIMITED", "PROVIDER_UNAVAILABLE"],
});
export const imSessionRoutes = [createImSession];
//# sourceMappingURL=session.routes.js.map